import React from 'react'

const Wowza = props => {
    return <div className="help__Wowza">
        <p><strong>Note:</strong> Please consult Wowza's documentation on how to setup a Wowza Live Stream and retrieve the Server URL and Stream Key.</p>
    </div>
}

export default Wowza